<template>
    <div class="app-main">
        
        <div class="top-bar">
            <el-input placeholder="输入订单号查询" v-model="title" @change="getData"  style="width:300px;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i> 
            </el-input>
            <!-- <el-button type="success" plain  style="width:150px;margin-left:20px;" @click="ok">确认发货</el-button> -->
            
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table ref="table" :data="tableData"  height="600" @selection-change="handleSelectionChange" >
                <el-table-column type="selection" align="center" width="60"></el-table-column>
                <el-table-column prop="title" label="订单号"  align="center" width="200"></el-table-column>
                <el-table-column prop="operator" label="处理人"  align="center" width="160"> </el-table-column>
                <el-table-column prop="date" label="处理时间"  align="center" width="160"> </el-table-column>
                <el-table-column prop="shname" label="收货人"  align="center" width="160"> 
                    <template slot-scope="scope" >
                        <el-link :underline="false" v-if="scope.row.shname != ''">{{scope.row.shname}}</el-link>
                        <el-link :underline="false" v-else>{{scope.row.nickname}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="shtel" label="联系方式"  align="center" width="160"> 
                    <template slot-scope="scope" >
                        <el-link :underline="false" v-if="scope.row.shtel != ''">{{scope.row.shtel}}</el-link>
                        <el-link :underline="false" v-else>{{scope.row.phone}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="carrier_name" label="配送物流"  align="center" width="160">
                    <template slot-scope="scope" >
                        <el-link :underline="false" v-if="scope.row.logistics_type == 0">MoobyYoho</el-link>
                        <el-link :underline="false" v-else-if="scope.row.logistics_type == 2">自提</el-link>
                        <el-link :underline="false" v-else-if="scope.row.logistics_type == 4">{{scope.row.carrier_name2}}</el-link>
                        <el-link :underline="false" v-else>{{scope.row.carrier_name}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="pick_code" label="取件码" align="center" width="140" >
                     <template slot-scope="scope" >
                        {{scope.row.order_logistics.pick_up_code}}
                    </template>
                </el-table-column>
                <el-table-column  label="订单状态" align="center" width="140">
                    <template slot-scope="scope">
                        <el-button type="text" v-if="scope.row.order_status == 4"  style="color:orange">运输中</el-button>
                        <el-button type="text" v-if="scope.row.order_status == 5">已送达</el-button>
                        <el-button type="text" v-if="scope.row.order_status == 13 " style="color:red">待发货</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="查看详情"  align="center" width="180">
                    <template slot-scope="scope">
                        <el-button  plain size="small"   @click="showDetail(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="确认送达"  align="center"  width="170" >
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.order_status == 4" @click="done(scope.row)" type="danger" plain size="small">确认送达</el-button>
                    </template>
                </el-table-column>
                
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next" style="padding:15px" :total="total" :page-size="20" ></el-pagination>
        </el-card>


    <!-- 展开商品详情弹框 -->
    <el-dialog title="订单详情" :visible.sync="detail_modal" :close-on-click-modal="false" center width="1200px" >
        <el-row>
            <el-col :span="12">
                <el-form ref="form" :model="form"  label-position="left" label-width="120px">
                    <el-form-item label="订单号码" inline class="detail-label">
                        <p>{{form.title}}</p>
                    </el-form-item>
                    <el-form-item label="下单账号" inline class="detail-label">
                        <p>{{form.phone}}</p>  
                    </el-form-item>
                    <el-form-item label="收货人" inline class="detail-label">
                        <p>{{form.date}}</p>  
                    </el-form-item>
                    <el-form-item label="联系电话" inline class="detail-label">
                        <p>{{form.date}}</p>  
                    </el-form-item>
                    
                    <el-form-item label="收货地址" inline class="detail-label">
                        <p  >{{form.shaddr}}</p>  
                    </el-form-item>
                    <el-form-item label="联系方式" inline class="detail-label">
                        <p >{{form.shtel}}</p>  
                    </el-form-item>
                    
                </el-form>
            </el-col>
            <el-col :span="12">
                <el-form label-position="left" label-width="120px">
                    <el-form-item label="发货物流" inline class="detail-label">
                        <p v-if="form.logistics_type == 0" >MoobyYoho</p>  
                        <p v-if="form.logistics_type == 1" >{{form.carrier_name}}</p>  
                        <p v-if="form.deliverymode == 2" >自提</p>  
                        <p v-if="form.deliverymode == 4" >其他</p> 
                    </el-form-item>
                    <el-form-item label="处理人" inline class="detail-label">
                        <p>{{form.operator}}</p>  
                    </el-form-item>
                    <el-form-item label="物流单号" inline class="detail-label" v-if="form.logistics_type == 1">
                        <img :src="url + form.logistics_pic" alt="img" style="height:80px;" @click="scaleImg(url + form.logistics_pic)">
                    </el-form-item>
                    <el-form-item label="自取码" inline class="detail-label" v-else-if="form.logistics_type == 2">
                        <p>{{form.pick_code}}</p>  
                    </el-form-item>
                    <el-form-item label="物流单号" inline class="detail-label" v-else-if="form.logistics_type == 0 || form.logistics_type == 4">
                        <p>{{form.title}}</p>  
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        
            <!-- <div class="shop" v-for="(it,index) in form.goodsinfo" :key="index"> -->
                <!-- <p style="line-height:40px;color:#666;font-size:16px;">{{it.order_title}}</p> -->
                <el-table :data="form.goodsinfo" max-height="300" style="width: 100%;border-top:1px solid #e0e0e0;">
                    <el-table-column label="商品图片"  align="center" width="100">
                        <template slot-scope="scope">
                            <div style="width:90px;"><img :src="url + scope.row.spec_pic.url" alt="img" style="width:80px;height:80px;object-fit:cover"></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品名称" show-overflow-tooltip  align="center" width="200">
                        <template slot-scope="scope">{{scope.row.goods_name}}</template>
                    </el-table-column>
                    <el-table-column label="商品规格"  align="center"  width="160" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.barcode.specstr}}</template>
                    </el-table-column>
                    <el-table-column label="条形码"  align="center"  width="180">
                        <template slot-scope="scope">{{scope.row.barcode.barcode}}</template>
                    </el-table-column>
                    <el-table-column label="购买数量"   align="center" width="80">
                        <template slot-scope="scope">{{scope.row.pronber}}</template> 
                    </el-table-column>
                    <el-table-column label="购买价格"  align="center">
                        <template slot-scope="scope">{{form.order_logistics.country == 507 ? 'US$' : 'C$'}}{{scope.row.price}}</template> 
                    </el-table-column>
                    <el-table-column label="PST"  align="center">
                        <template slot-scope="scope">{{form.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.tax_a }}</template> 
                    </el-table-column>
                    <el-table-column label="GST"  align="center">
                        <template slot-scope="scope">{{form.order_logistics.country == 507 ? 'US$' : 'C$'}}{{ scope.row.tax_b }}</template> 
                    </el-table-column>
                </el-table>
            <!-- </div> -->
            
        
        <div class="detail-total">
            <el-button  @click="exportCard()" type="danger"  style="width:300px">打印配送单</el-button>
        </div>
    </el-dialog>

    <el-dialog :visible.sync="scaleModal">
            <img width="100%" :src="scaleUrl" alt="img">
        </el-dialog>

    </div>
</template>



<script>


export default {
    data() {
        return {
            url:'',
            date:[],
            title: '',
            companyList:[],
            company:'',
            checkList:[],
            tableData:[],
            status:0,
            total:0,
            page:1,
            detail_id:"",
            detail_modal:false,
            form:{},
            checkData:[],                   //选中通知库房的数据
            scaleModal:false,
            scaleUrl:"",
        }
    },
    methods: {
        getData(){
            
        },
        // 点击页数 加载当前点击页的数据
        reloadData(page){
            this.page = page;
            this.getData();
        },
        // 查询订单 日期或者订单号
        search(){
            
        },
        // 显示订单详情
        showDetail(row){
            this.form = row;
            this.detail_modal = true;
        },
        handleSelectionChange(rows){
            rows.forEach(ele => {
                if(ele.order_status == 13){
                    this.checkData.push(ele.title)
                }
            })
        },
        ok(){
            
        },
        done(){
            
        },
        scaleImg(url){
            this.scaleUrl   = url;
            this.scaleModal = true;
        },
        exportCard(){
        },
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>



<style lang="less" scoped>
.border-box {
    box-sizing: border-box;
}

.warehouse-goodspost {

    .content {
        width: 100%;
        .shopImg {
            width: 80px;
            height: 80px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .detail-label {
        color: #99a9bf;
        margin-bottom: 10px;
        padding-left: 30px;
        box-sizing: border-box;
    }
    .detail-total {
        width: 100%;
        padding: 10px 15px;
        margin: 25px 0;
        box-sizing: border-box;
        text-align: center;
    }
}
</style>
